import { motion } from 'framer-motion';

export const ScrollReveal = ({ children, delay = 0, y = 24, className = '', testid }) => (
    <motion.div
        data-testid={testid}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Stagger = ({ children, className = '', delay = 0.08 }) => (
    <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: '-80px' }}
        variants={{
            hidden: {},
            show: { transition: { staggerChildren: delay, delayChildren: 0.1 } },
        }}
        className={className}
    >
        {children}
    </motion.div>
);

export const StaggerItem = ({ children, className = '', testid }) => (
    <motion.div
        data-testid={testid}
        variants={{
            hidden: { opacity: 0, y: 18 },
            show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
        }}
        className={className}
    >
        {children}
    </motion.div>
);
